export const getTimePeriod = (): 'morning' | 'afternoon' | 'evening' => {
  const now = new Date()
  const minutesSinceMidnight = now.getHours() * 60 + now.getMinutes()

  if (
    minutesSinceMidnight >= 1 && // 00:01
    minutesSinceMidnight <= 12 * 60 // 12:00
  ) {
    // 00:01-12:00
    return 'morning'
  } else if (
    minutesSinceMidnight >= 12 * 60 + 1 && // 12:01
    minutesSinceMidnight <= 17 * 60 // 17:00
  ) {
    // 12:01-17:00
    return 'afternoon'
  } else {
    // 17:01-00:00
    return 'evening'
  }
}
